export class BaseFeaturesAddon {
    constructor(name, options = {}) {
        this.customFeatures = null;
        this.options = {
            ...{},
            ...options,
        };
    }
    _handle(customFeatures) {
        this.customFeatures = customFeatures;
    }
}
